import { render } from "./IconRoundaboutLeftAlt.vue?vue&type=template&id=4868cf6a"
import script from "./IconRoundaboutLeftAlt.vue?vue&type=script&lang=js"
export * from "./IconRoundaboutLeftAlt.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__